var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content',{staticClass:"h-panel"},[_c('div',{staticClass:"h-panel-bar"},[_c('span',{staticClass:"h-panel-title"},[_vm._v(_vm._s(_vm.$route.meta.title))])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }